import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Adjust"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 5.25001H18.675C18.3201 3.50226 16.7834 2.24625 15 2.24625C13.2166 2.24625 11.6799 3.50226 11.325 5.25001H1.5V6.75001H11.325C11.6799 8.49775 13.2166 9.75377 15 9.75377C16.7834 9.75377 18.3201 8.49775 18.675 6.75001H22.5V5.25001ZM15 8.25001C13.7574 8.25001 12.75 7.24265 12.75 6.00001C12.75 4.75737 13.7574 3.75001 15 3.75001C16.2426 3.75001 17.25 4.75737 17.25 6.00001C17.25 7.24265 16.2426 8.25001 15 8.25001ZM1.5 18.75H5.325C5.67989 20.4977 7.21659 21.7538 9 21.7538C10.7834 21.7538 12.3201 20.4977 12.675 18.75H22.5V17.25H12.675C12.3201 15.5023 10.7834 14.2462 9 14.2462C7.21659 14.2462 5.67989 15.5023 5.325 17.25H1.5V18.75ZM6.75 18C6.75 16.7574 7.75736 15.75 9 15.75C10.2426 15.75 11.25 16.7574 11.25 18C11.25 19.2426 10.2426 20.25 9 20.25C7.75736 20.25 6.75 19.2426 6.75 18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Adjust.vue"]]);
